export default "__VITE_ASSET__BKAHcx79__"